import { trackingPageSettingsSchema } from "@redotech/redo-model/order-tracking/tracking-page-definition";
import * as z from "zod";

export const updateTrackingPageSettings = {
  name: "updateTrackingPageSettings" as const,
  input: trackingPageSettingsSchema,
  output: z.object({ success: z.boolean() }),
};
